import request from '@/utils/axios'

// 获取用户邀请信息
export function fetchUserInviteInfo() {
  return request({
    url: '/userCenter/getInviteInfo',
    method: 'post',
  })
}

// 获取邀请明细列表
export function fetchInviteUserList(data) {
  return request({
    url: '/userCenter/getInviteUserList',
    method: 'post',
    data,
  })
}

// 获取邀请返佣列表
export function fetchInviteRebateList(data) {
  return request({
    url: '/userCenter/getInviteRebateList',
    method: 'post',
    data,
  })
}

// 获取合伙人返佣列表
export function fetchPartnerRebateList(data) {
  return request({
    url: '/userCenter/getPartnerRebateList',
    method: 'post',
    data,
  })
}
